export default "/images/5b971c8e791bcd62dff18bb380ffbe2a.avif";